import { useCallback } from 'react';
import { useInquiryDetail } from '../../features/inquiry/hooks/useInquiryDetail';
import { appBridge } from '../services/bridge';

interface UseDoctorRouteGuardReturn {
  /** ドクタールートのためブロックすべきか */
  shouldBlock: boolean;
  /** inquiry 取得中か */
  isLoading: boolean;
  /** OK ボタン押下時: Flutter のダッシュボードへ強制復帰 */
  handleConfirm: () => void;
}

/**
 * ドクタールート監視ガードフック
 *
 * 指定の inquiry をマウント時に取得し、processedSystem が 'home-karte' 以外
 * （'home-doctor' / '' / undefined）であればブロック対象として shouldBlock=true を返す。
 *
 * 既存 InquiryDetail.tsx の isKarteProcessing 判定と同じロジック。
 *
 * ローディング中・エラー時はブロックしない（呼び出し元の責務でローディング/エラー表示）。
 *
 * @param inquiryId 監視対象の inquiry ID。undefined の場合は何もしない。
 * @param token 認証トークン（任意）
 */
export const useDoctorRouteGuard = (
  inquiryId: string | undefined,
  token?: string,
): UseDoctorRouteGuardReturn => {
  const { data: inquiry, isLoading, error } = useInquiryDetail(inquiryId ?? '', token);

  const shouldBlock =
    !!inquiryId &&
    !isLoading &&
    !error &&
    inquiry !== null &&
    inquiry.processedSystem !== 'home-karte';

  const handleConfirm = useCallback(() => {
    appBridge.navigateToDashboard();
  }, []);

  return {
    shouldBlock,
    isLoading,
    handleConfirm,
  };
};
